<template>
  <nav class="navigation-bar">
    <div
      class="navigation-bar__container"
      :class="{ 'is-column': isColumn }"
    >
      <slot></slot>
    </div>
  </nav>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'NavigationBar',
    props: {
      isColumn: {
        type: Boolean,
        default: false,
      }
    },
    setup() {
      return {}
    },
  })
</script>

<style lang="scss" scoped>
  .navigation-bar {
    background-color: $clr-white;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 1rem;
    box-shadow: $box-shadow-card;
    z-index: 10;

    &__container {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
      max-width: 100%;
      margin: 0 auto;

      @media screen and (min-width: $breakpoint-xs) {
        max-width: $main-width;
        justify-content: flex-end;
      }

      @media screen and (max-width: $breakpoint-sm) {
        &.is-column {
          flex-direction: column;
          align-items: stretch;
          gap: 16px;
        }
      }
    }
  }
</style>
